module.exports = __webpack_public_path__ + "static/media/12.41937dc9.jpg";